"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoritesHeartIconButton = void 0;
var _react = require("react");
var _contexts = require("../../contexts");
var _FavoritesHeart = require("../FavoritesHeart");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FavoritesHeartIconButton = ({
  code,
  placement,
  position,
  productListId,
  shades,
  onClick,
  ...restProps
}) => {
  const {
    initialized
  } = (0, _contexts.useFavorites)();
  const handleClick = (0, _react.useCallback)(e => {
    e.preventDefault();
    e.stopPropagation();
    onClick?.(e);
  }, [onClick]);
  const renderFavoritesHeart = (0, _react.useCallback)((heart, onFavoritesHeartClick) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FavoritesIconButton, {
    color: "default",
    size: "large",
    variant: "contained",
    disabled: !initialized,
    onClick: onClick ? handleClick : onFavoritesHeartClick,
    ...restProps,
    children: heart
  }), [handleClick, initialized, onClick, restProps]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FavoritesHeart.FavoritesHeart, {
    code: code,
    productListId: productListId,
    placement: placement,
    position: position,
    shades: shades,
    render: renderFavoritesHeart
  });
};
exports.FavoritesHeartIconButton = FavoritesHeartIconButton;
